import React, { forwardRef } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { InfoIcon, InputErrorMessage, Label } from 'components'
import useInputError from 'hooks/useInputError'
import { COLORS, INPUT, BASE_INPUT } from '../styles'

const Input = forwardRef(
  (
    {
      label,
      classNames,
      styles,
      icon,
      showInvalidMessage,
      useBaseInputStyles,
      children,
      onBlur,
      onChange,
      onFocus,
      onInvalid,
      onError,
      ...rest
    },
    ref
  ) => {
    const { errorMessage, handleError, setErrorMessage } = useInputError(onError)
    const content = (
      <div className={classnames({ [classNames.container]: !label })}>
        <div className={classnames(classNames.inputContainer, 'relative')}>
          <div className="relative">
            <input
              ref={ref}
              className={classnames(useBaseInputStyles ? BASE_INPUT : INPUT, classNames.input, {
                'pl-14': !!icon,
              })}
              onChange={e => {
                setErrorMessage(null)
                onChange(e)
              }}
              onInvalid={e => {
                handleError(e)
                onInvalid(e)
              }}
              style={styles.input}
              {...rest}
            />
            {icon && (
              <div className="w-4 absolute left-6 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center">
                {icon}
              </div>
            )}
          </div>
          {showInvalidMessage && errorMessage && (
            <div
              className={classnames(
                'absolute top-1/2 bottom-0 right-5 transform -translate-y-1/2 flex justify-center items-center w-4 h-4 border border-solid border-frolyPink rounded-full',
                classNames.errorMessage
              )}
            >
              <InfoIcon className="text-frolyPink w-0.5" />
            </div>
          )}
          {children}
        </div>
        {showInvalidMessage && errorMessage && (
          <InputErrorMessage className="block mt-2.5">{errorMessage}</InputErrorMessage>
        )}
      </div>
    )
    return label ? (
      <Label
        label={label}
        classNames={{ label: classNames.container, span: 'font-tomatoGrotesk-reg font-bold' }}
        styles={{
          span: {
            color: COLORS.REGENT_GRAY,
          },
        }}
      >
        {content}
      </Label>
    ) : (
      content
    )
  }
)

Input.propTypes = {
  onError: PropTypes.func,
  showInvalidMessage: PropTypes.bool,
  label: PropTypes.string,
  styles: PropTypes.shape({
    input: PropTypes.object,
  }),
  classNames: PropTypes.shape({
    container: PropTypes.string,
    inputContainer: PropTypes.string,
    input: PropTypes.string,
    errorMessage: PropTypes.string,
  }),
  icon: PropTypes.object,
}

Input.defaultProps = {
  classNames: {},
  styles: {},
  onError: e => e.target.validationMessage,
  onFocus: () => {},
  onBlur: () => {},
  onChange: () => {},
  onInvalid: () => {},
  showInvalidMessage: true,
}

export default Input
